<template>
  <div id="maps" style="position: relative; width: 100%; height: 100%;">
  </div>
</template>
<style>
  @import '../../assets/css/gojs/DataMapsContextMenu.css';
</style>
<style>
  .datamaps-subunits{
    cursor: pointer;
  }
</style>
<script>

import Datamap from 'datamaps'
import IsoCountries from 'i18n-iso-countries'
import EnCountries from '../../iconFlag/en'
IsoCountries.registerLocale(EnCountries)

export default {
  components: {
  },
  data () {
    return {
      dataset: {},
      paletteScale: null,
      map: null
    }
  },
  props: ['countries', 'companies', 'height'],
  name: 'MapsByAffiliation',
  watch: {
    countries: function (val) {
      setTimeout(() => {
        this.init()
      }, 2000)
    }
  },
  methods: {
    init: function () {
      let parentWidth = $('#maps').parent().width()
      document.getElementById('maps').style.width = parentWidth + 'px'
      document.getElementById('maps').style.height = this.height + 'px'

      let countries = []
      let self = this
      this.countries.forEach((country) => {
        let iso = IsoCountries.getAlpha3Code(country.name, 'en')
        let topOrganisations = []
        let count = 0
        this.companies.forEach((company) => {
          if (typeof country.name !== 'undefined' && typeof company.country !== 'undefined' && company.country.toLowerCase() === country.name.toLowerCase() && count < 5) {
            topOrganisations.push(company)
            count++
          }
        })
        if (typeof iso !== 'undefined') {
          countries.push({iso, nb: country.nb, topOrga: topOrganisations })
        }
      })

      let minMath = []

      this.countries.forEach(function (country) { //
        minMath.push(country.nb)
      })

      this.paletteScale = d3.scale.linear()
        .domain([Math.min(...minMath), Math.max(...minMath)])
        .range(['#b5ef9e', '#8dd869']) // blue color

      this.dataset = {}
      countries.forEach((country) => {
        this.dataset[country.iso] = { numberOfThings: country.nb, fillColor: this.paletteScale(country.nb), topOrga: country.topOrga }
        minMath.push(country.nb)
      })

      $('#maps').empty()
      this.map = new Datamap({
        element: document.getElementById('maps'),
        projection: 'mercator',
        fills: {
          defaultFill: '#cfefc3'
        },
        data: this.dataset,
        geographyConfig: {
          highlightFillColor: function (geo) {
            return geo['fillColor'] || '#F5F5F5'
          },
          popupTemplate: function (geo, data) {
            let str = ''
            if (data !== null && data.topOrga.length !== 0) {
              data.topOrga.forEach((orga) => {
                str += '<div class="option datamaps-option"  title="' + orga.name + '">' + orga.name + ' (' + orga.nb + ')</div>'
              })
            }
            return ['<div class="dataMapsContextMenu"><div class="heading text-center"><strong>' + geo.properties.name + '</strong></div>' +
              '<div><hr class="m-xs"></div>' + str + '</div>'].join('')
          }
        },
        done: function (datamap) {
          datamap.svg.selectAll('.datamaps-subunit').on('click', function (geography) {
            self.refineWithCountry(geography.properties.name)
          })
        }
      })

      if ($('#noDataMapsAffiliation').length !== 0) {
        $('#noDataMapsAffiliation').remove()
      }

      if (this.companies.length === 0) {
        let div = document.createElement('div')

        div.textContent = 'no data'
        div.style.position = 'absolute'
        div.style.top = '150px'
        div.style.width = '100%'
        div.className = 'text-center'
        div.id = 'noDataMapsAffiliation'
        this.$el.append(div)
      }
    },
    refineWithCountry: function (country) {
      this.$eventHub.$emit('refineWithCountry', country)
    },
    diagramResize: function () {
      this.init()
    },
    draw: function () {
      this.init()
    }
  },
  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/MapsByAffiliation.vue